import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import ReceiptPDF from './ReceiptPDF';

const ReceiptDownloadButton = ({ transaction, type, buttonText = "View Receipt" }) => {
  // This ensures the component only renders on client side
  const [isClient, setIsClient] = React.useState(false);
  
  React.useEffect(() => {
    setIsClient(true);
  }, []);

  // Build the display Transaction ID in the same way as the PDF
  const getDisplayTransactionId = () => {
    const fallbackId = String(transaction?.id ?? "").padStart(3, "0");
    const shortId = transaction?.transaction_id || fallbackId;
    switch (type) {
      case 'material':
        return transaction?.po_number ? transaction.po_number : `DLVRY-${shortId}`;
      case 'worker':
        return `WORKER_PAY-${shortId}`;
      case 'refund':
        return `TRN-${shortId}`;
      case 'other':
        return `TRN-${shortId}`;
      default:
        return `TRN-${shortId}`;
    }
  };

  // Generate a useful filename based on transaction type and data (include ID)
  const generateFilename = () => {
    let prefix = '';
    
    switch (type) {
      case 'material':
        prefix = 'Material_Purchase';
        break;
      case 'worker':
        prefix = 'Worker_Payment';
        break;
      case 'refund':
        prefix = 'Refund';
        break;
      default:
        prefix = 'Transaction';
    }

    return `${prefix}_Receipt_${getDisplayTransactionId()}.pdf`;
  };

  // Only render the PDFDownloadLink on the client side to avoid SSR issues
  return isClient ? (
    <PDFDownloadLink
      document={<ReceiptPDF transactionData={transaction} type={type} />}
      fileName={generateFilename()}
      className="px-4 py-2 bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 flex items-center gap-2"
    >
      {({ blob, url, loading, error }) =>
        loading ? 'Generating receipt...' : buttonText
      }
    </PDFDownloadLink>
  ) : (
    <button
      className="px-4 py-2 bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 flex items-center gap-2"
      disabled
    >
      {buttonText}
    </button>
  );
};

export default ReceiptDownloadButton;